/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Session_CheckingInputs */

const en_auth_session_checking = /** @type {(inputs: Auth_Session_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking your session...`)
};

/**
* | output |
* | --- |
* | "Checking your session..." |
*
* @param {Auth_Session_CheckingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_session_checking = /** @type {((inputs?: Auth_Session_CheckingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Session_CheckingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_session_checking(inputs)
});